import RegisterBG from "./registerbg.jpg";
import QAProtocol_icon from "./QAProtocol_icon.png";
import Files_icon from "./Files_icon.png";
import Backlog_icon from "./Backlog_icon.png";
import Sprint_icon from "./Sprint_icon.png";
import Kanbanboard_icon from "./Kanbanboard_icon.png";
import AppLogo from "./VC-Logo.png";
import WithTemplate from "./template.png";
import WebLogo from "./logo.png";
import ProfileAvatar from "./profile-avatar.png";
import CovidBg from "./covidBg.jpg";
import DragAble from "./Vector.png";
import VCLogo from "./logo.png";
import HeaderImage from "./header_image.png";
import NicePerson from "./nicePerson.png";
import SectionTwobg from "./section2_Bg.png";
import SectionThreeg from "./Section3_Bg.png";
import SectionImage from "./section2_Image.png";
import SectionThreeImage from "./Section3_Image.png";
import WorkFlow from "./workflow.png";
import LandingpageLogo from "./landingpage-logo.png";
import header_bg from "./header_bg.png";
import dashboard_icon from "./dashboard_icon.png";
import kanban_icon from "./kanban_icon.png";
import employement_icon from "./management_icon.png";
import Hr_icon from "./HR_icon.png";
import AI_icon from "./AI_icon.png";
import Stats_icon from "./stat.png";
import Clouds_icon from "./cloudfile_icon.png";
import Workload_icon from "./workload_icon.png";
import Protection_icon from "./security_icon.png";
import Calling_icon from "./videocalling_icon.png";
import My_work_icon from "./mywork_icon.png";
import calendar_icon from "./Calendar_icon.png";
import todo_icon from "./todo_icon.png";
import finance_icon from "./finance_icon.png";
import crm_icon from "./CRM_icon.png";
import mobile_phones from "./mobilephones_Image.png";
import Vc_Icon from "./VC_icon.png";
import Android_icon from "./android_download_icon.png";
import Apple_icon from "./Apple_download_icon.png";
import Testimonial_logo from "./testimonial-logo.png";
import Right_comas from "./right_comas.png";
import Footer_logo from "./logo_footer.png";
import FlowChartVideo from "./Structure Model.m4v";
import Project from "./project.png";
import VCKanban from "./VC kanban.png";
import Video from "./video call.png";
import Workload from "./Workload.png";
import Reject from "./reject.png";
import Approved from "./approved.png";
import CovisLogo from "./Ccovis-logo.png";
import GmailLogo from "./Gmail-Logo.png";
import Zoomlogo from "./zoom-logo-png.webp";
import sideImage from "./krakenimages.png";
import grediantImage from "./Rectangle18016.png";
import Grid_View from "./GridView.png";
import List_View from "./ListView.png";
import VC_Landing_Logo from "./VC_Landing_Logo.png";
import VC_Landing_LogoText from "./VC_Landing_LogoText.png";
import background_shadow from "./background_shadow.png";
import square from "./square.png";
import bg_triangle from "./bg_triangle.png";
import target_market_main_img from "./target_market_main_img.png";
import dashboard_main_img from "./dashboard_main_img.png";
import QA_main_img from "./QA_main_img.png";
import team_main_img from "./team_main_img.png";
import project_main_img from "./project_main_img.png";
import pricing_vector_right from "./pricing-vector-right.png";
import dashboard from "./dashboard.png";
import stats from "./stats.png";
import my_work from "./my-work.png";
import kanban_board from "./kanban-board.png";
import cloud_storage from "./cloud-storage.png";
import calendar from "./calendar.png";
import employee_management from "./employee-management.png";
import hr_image from "./hr-image.png";
import security from "./security.png";
import finance from "./finance.png";
import todo from "./todo.png";
import artificial_intelligence from "./artificial-intelligence.png";
import video_calling from "./video-calling.png";
import crm from "./crm.png";
import workload_management from "./workload-management.png";
import features_left_triangle from "./features-left-triangle.png";
import testimonials_icon from "./testimonials-icon.png";
import app_logo from "./app-logo.png";
import TemplateImage from "./123.png";
import demoimage from "./demoimage.png";
import teerImage from "./teerImage.png";
import users from "./users.png";
import magnetImage from "./magnetImage.png";
import konImage from "./konImage.png";
import dealClosed from "./dealClosed.png";
import singOutImg from "./singOutImg.png";
// import { hr } from "date-fns/locale";
import socialfacebook from "./social-facebook.png";
import socialinsta from "./social-insta.png";
import socialtwitter from "./social-twitter.png";
import socialyoutube from "./social-youtube.png";
import ProjectsMain from "./ProjectsMain.png";
// import workLoadMain from "./Workload-Main.png"
import spritMain from "./Sprints_Main.png";
import workloadmain from "./Workload_Main.png";
import workScheduler from "./Work_Scheduler.png";
import ceoDashboard from "./CEO.png";
import cfoDashboard from "./CFO.png";
import resourceTracking from "./ResourceTracking.png";
import Recruitment from "./Recruitment.png";
import file_uploader_img from "./file_uploader_img.png";
import Attendenceimage from "./Attendenceimage.png";
import Hiringimage from "./Hiringimage.png";
import Recruitmentimg from "./Recruitmentimg.png";
import linkedinFooter from "./linkedin-footer.png";
import FinanceIncome from "./FinanceIncome.png";
import RsProductivity from "./RsProductivity aanalysis.png";
import EmProductivity from "./EmployeeProductivity.png";
import jarvisflow from "./jarvisflow.jpg";
import File_Cloud from "./File_Cloud.png";
import AIFeatures from "./AIFeatures.png";
import CloudFileStorage from "./Cloud File Storage.png";
import Multitenancy from "./Multi-tenancy management.png";
import ReportsStats from "./Reports & Stats.png";
import smartKanban from "./smartKanban.png";
import WorkloadManagement from "./Workload Management.png";
import TeamScheduler from "./Team Scheduler.png";
import DayPlannerfeature from "./DayPlanner.png";
import EmployeeManagement from "./Employee Management.png";
import RecruitmentFunnel from "./Recruitment Funnel.png";
import TalentPool from "./Talent Pool.png";
import ResourceTracking from "./Resource Tracking.png";
import ProductivityAnalysis from "./Productivity Analysis.png";
import JobPost from "./JobPost.png";
import ResourceTrackingfeature from "./Resource Tracking feature.png";
import Payrollfeature from "./Payroll.png";
import Incomeexpense from "./Income & expense.png";
import Revenue from "./Revenue.png";
import GAExpense from "./G & A Expense.png";
import Day_PlannerMAin from "./Day_PlannerMAin.png";
import featureSquare from "./feature-square-little.png";
import projectManagementIcon from "./ProjectManagementIcon.png";
import hrManagerIcon from "./HRManagerIcon.png";
import resourceTrackerIcon from "./ResourceTrackerIcon.png";
import financialSystemIcon from "./FinancialSystemIcon.png";
import fileCloudIcon from "./FileCloudIcon.png";
import simon from "./simon.jpg";
import dummyPerson from "./dummyPerson.jpg";
import notificatio1 from "./notification1.png";
import notificatio2 from "./notification2.png";
import notificatio3 from "./notification3.png";
import notificatio4 from "./notification4.png";
import notificatio5 from "./notification5.png";
import drMaida from "./drMaida.png";
import umar from "./umar.jpg";
import hammadDogar from "./hammadDogar.jpeg";
import xevenLogo from "./xeven-logo.png";
import vectorLeft from "./vector-left.png";
import vectorRight from "./vector-right.png";

export const IMAGES = {
  NOTIFICATION5: notificatio5,
  NOTIFICATION4: notificatio4,
  NOTIFICATION3: notificatio3,
  NOTIFICATION2: notificatio2,
  NOTIFICATION1: notificatio1,
  FEATURESQURE: featureSquare,
  DAYPLANNERMAIN: Day_PlannerMAin,
  REATUREFEATURE: Revenue,
  GAEXPENCE: GAExpense,

  INCOMEEXPENCEFEATURE: Incomeexpense,
  PYROLLFEATURE: Payrollfeature,
  RESOURCEFEATURE: ResourceTrackingfeature,
  JOBPOST: JobPost,
  PRODUCTANALISIC: ProductivityAnalysis,
  RESOURCETRACKING: ResourceTracking,
  TELENTPOOL: TalentPool,
  RECRUITMENTFUNNEL: RecruitmentFunnel,
  EMPMANAGEMENTS: EmployeeManagement,
  DAYPLANNERFEATURE: DayPlannerfeature,
  TEAMSCHEDULAR: TeamScheduler,
  WORKLOADMANGEMENT: WorkloadManagement,
  SMARTKANBAN: smartKanban,
  REPPOSTSSTARS: ReportsStats,
  MULTITENDENCY: Multitenancy,
  CLOUDFILESTORAGE: CloudFileStorage,
  AIFEATURES: AIFeatures,
  FILECLOUD: File_Cloud,
  JARVISFLOW: jarvisflow,
  EMPRODUCTIVITY: EmProductivity,
  RSPRODUCTIVITY: RsProductivity,
  FINANCEINCOME: FinanceIncome,
  LINKEDINFOOTER: linkedinFooter,
  RECRUITMENTIMG: Recruitmentimg,
  HIRINGIMAGE: Hiringimage,
  ATTENDANCEIMAGE: Attendenceimage,
  RECRUITMENT: Recruitment,
  CEODASHBOARD: ceoDashboard,
  CFODASHBOARD: cfoDashboard,
  RESOURCETRACKING: resourceTracking,
  WORKSCHEDULER: workScheduler,
  WORKLOADMAIN: workloadmain,
  SPRINTMAIN: spritMain,
  PROJECTMIAN: ProjectsMain,
  SOCAILFACEBOOK: socialfacebook,
  SOCAILYOUTUBE: socialyoutube,
  SOCAILTWITTER: socialtwitter,
  SOCAILINSTA: socialinsta,
  TEMPLATEIMAGE: TemplateImage,
  PROJECT_MAIN_IMG: project_main_img,
  TEAM_MAIN: team_main_img,
  QA_MAIN: QA_main_img,
  DASHBOARD_MAIN: dashboard_main_img,
  TARGET_MARKET_MAIN: target_market_main_img,
  BG_TRIANGLE: bg_triangle,
  SQUARE: square,
  BACKGROUND_SHADOW: background_shadow,
  VC_LANDING_LOGO: VC_Landing_Logo,
  VC_LANDING_LOGOTEXT: VC_Landing_LogoText,
  WITHTEMPLATE: WithTemplate,
  SIGNOUTIMG: singOutImg,
  GRID_VIEW: Grid_View,
  DEMOIMAGE: demoimage,
  LIST_VIEW: List_View,
  BACKLOG_ICON: Backlog_icon,
  SPRINT_ICON: Sprint_icon,
  QAPROTOCOL_ICON: QAProtocol_icon,
  FILES_ICON: Files_icon,
  KANBAN_BOARD_ICON: Kanbanboard_icon,
  VIDEO: Video,
  ZOOMLOGO: Zoomlogo,
  GREDIENTIMAGE: grediantImage,
  SIDEIMAGE: sideImage,
  WORKLOAD: Workload,
  PROJECT: Project,
  VCKANBAN: VCKanban,
  VCLOGO: VCLogo,
  REGISTERBG: RegisterBG,
  APPLOGO: AppLogo,
  WEBLOGO: WebLogo,
  AVATAR: ProfileAvatar,
  COVIDBG: CovidBg,
  DRAGABLE: DragAble,
  HEADERIMAGE: HeaderImage,
  NICEPERSON: NicePerson,
  SECTIONTWO: SectionTwobg,
  SECTIONTHREE: SectionThreeg,
  SECTIONTWOImage: SectionImage,
  SECTIONTREEIMAGE: SectionThreeImage,
  WORKFLOW: WorkFlow,
  LANDINGPAGELOGO: LandingpageLogo,
  HEADER_BG: header_bg,
  DASHBOARD_ICON: dashboard_icon,
  KANBAN_ICON: kanban_icon,
  EMPLOYEEMENT_ICON: employement_icon,
  HR_ICON: Hr_icon,
  AI_ICON: AI_icon,
  STATS_ICON: Stats_icon,
  CLOUDS_ICON: Clouds_icon,
  WORKLOAD_ICON: Workload_icon,
  PROTECTION_ICON: Protection_icon,
  CALLING_ICON: Calling_icon,
  MY_WORK_ICON: My_work_icon,
  CALENDAR_ICON: calendar_icon,
  TODO_ICON: todo_icon,
  FINANCE_ICON: finance_icon,
  CRM_ICON: crm_icon,
  MOBILE_PHONES: mobile_phones,
  VC_ICON: Vc_Icon,
  ANDROID_ICON: Android_icon,
  APPLE_ICON: Apple_icon,
  TESTIMONIAL_LOGO: Testimonial_logo,
  RIGHT_COMAS: Right_comas,
  FOOTER_LOGO: Footer_logo,
  FLOWCHART_VIDEO: FlowChartVideo,
  REJECT: Reject,
  APPROVED: Approved,
  COVIS: CovisLogo,
  GMAILLOGO: GmailLogo,
  CONVERTEDLEADS: konImage,
  NUMBERLEADS: magnetImage,
  USERS: users,
  TARGETIMAGE: teerImage,
  DEALCLOSED: dealClosed,
  PRICINGVECTORRIGHT: pricing_vector_right,
  DASHBOARD: dashboard,
  STATS: stats,
  MY_WORK: my_work,
  KANBAN_BOARD: kanban_board,
  CLOUD_STORAGE: cloud_storage,
  CALENDAR: calendar,
  EMPLOYEE_MANAGEMENT: employee_management,
  HR_IMAGE: hr_image,
  SECURITY: security,
  FINANCE: finance,
  TODO: todo,
  ARTIFICIAL_INTELLIGENCE: artificial_intelligence,
  VIDEO_CALLING: video_calling,
  CRM: crm,
  WORKLOAD_MANAGEMENT: workload_management,
  FEATURES_LEFT_TRIANGLE: features_left_triangle,
  TESTIMONIALS_ICON: testimonials_icon,
  APP_LOGO: app_logo,
  FILE_UPLOADER_IMG: file_uploader_img,
  PROJECT_MANAGEMENT_ICON: projectManagementIcon,
  HRMANAGER_ICON: hrManagerIcon,
  RESOURCE_TRACKER_ICON: resourceTrackerIcon,
  FINANCIAL_SYSTEM_ICON: financialSystemIcon,
  FILE_CLOUD_ICON: fileCloudIcon,
  SIMON: simon,
  DUMMY_PERSON: dummyPerson,
  DR_MAIDA: drMaida,
  DR_UMAR: umar,
  HAMMAD_DOGAR: hammadDogar,
  XEVEN_LOGO: xevenLogo,
  VECTOR_LEFT: vectorLeft,
  VECTOR_RIGHT: vectorRight,
};
